export const items = [
  {
    id: 1,
    name: "Bubbles",
    category: "Dog",
    sex: "Male",
    color: "Golden",
    breed: "Shih tzu",
    age: "2-month old",
    image: "../images/Pet photo1.png",
  },
  {
    id: 2,
    name: "Reesee",
    category: "Cat",
    sex: "Female",
    color: "Brown",
    breed: "Short Hair",
    age: "2-month old",
    image: "../images/Pet photo.png",
  },
  {
    id: 3,
    name: "Prada",
    category: "Dog",
    sex: "Female",
    color: "White",
    breed: "Chihuaha",
    age: "8-month old",
    image: "../images/Screenshot2024.png",
  },

  {
    id: 4,
    name: "Hex",
    category: "Dog",
    sex: "Male",
    color: "Brown",
    breed: "Pitbull",
    age: "6-month old",
    image: "../images/Screenshot2025.png",
  },

  {
    id: 5,
    name: "Toddler",
    category: "Cat",
    sex: "Female",
    color: "Black",
    breed: "Short Hair",
    age: "7-month old",
    image: "../images/Pet photo2.png",
  },
  {
    id: 6,
    name: "Lucy",
    category: "Dog",
    sex: "Female",
    color: "Brown",
    breed: "Terrier",
    age: "7-month old",
    image: "../images/Screenshot2012.webp",
  },
  {
    id: 7,
    name: "Mack",
    category: "Cat",
    sex: "Male",
    color: "Brown",
    breed: "Short Hair",
    age: "7-month old",
    image: "../images/Furr-Ever friends near you_4.png",
  },
  {
    id: 8,
    name: "Danii",
    category: "Cat",
    sex: "Female",
    color: "Brown",
    breed: "Short Hair",
    age: "3-month old",
    image: "../images/Screenshot2023.png",
  },
  {
    id: 9,
    name: "Mabel",
    category: "Cat",
    sex: "Female",
    color: "Black",
    breed: "Short Hair",
    age: "10-month old",
    image: "../images/Screenshot2021.png",
  },
  {
    id: 10,
    name: "Chloe",
    category: "Small Critter",
    sex: "Female",
    color: "Grey",
    breed: "Chinchilla",
    age: "5-year old",
    image: "../images/Screenshot2022.jpg",
  },
  {
    id: 11,
    name: "Luke",
    category: "Dog",
    sex: "Male",
    color: "Brown",
    breed: "Spaniel",
    age: "5-year old",
    image: "../images/Screenshot2028.jpg",
  },
  {
    id: 12,
    name: "Batman",
    category: "Cat",
    sex: "Male",
    color: "Black",
    breed: "Short Hair",
    age: "3-year old",
    image: "../images/Screenshot2027.png",
  },
  {
    id: 13,
    name: "Pogo",
    category: "Cat",
    sex: "Female",
    color: ["Black", "White"],
    breed: "Long Hair",
    age: "8-year old",
    image: "../images/Screenshot2020.png",
  },
  {
    id: 15,
    name: "Rascal",
    category: "Cat",
    sex: "Male",
    color: ["White", "Grey"],
    breed: "Long Hair",
    age: "11-year old",
    image: "../images/Screenshot2029.jpg",
  },
  {
    id: 16,
    name: "Jaxon",
    category: "Dog",
    sex: "Male",
    color: "Black",
    breed: "German Shepard",
    age: "5-month old",
    image: "../images/Screenshot2016.jpg",
  },

  {
    id: 17,
    name: "Smoothie",
    category: "Cat",
    sex: "Male",
    color: ["Black", "White"],
    breed: "Tuxedo",
    age: "11-month old",
    image: "../images/Screenshot2017.webp",
  },

  {
    id: 18,
    name: "Brownie",
    category: "Dog",
    sex: "Female",
    color: "Brown",
    breed: "Pitbull",
    age: "1-month old",
    image: "../images/Screenshot2015.jpg",
  },
  {
    id: 19,
    name: "Finn",
    category: "Cat",
    sex: "Male",
    color: ["Orange"],
    breed: "Short Hair",
    age: "2-month old",
    image: "../images/Screenshot2014.jpg",
  },

  {
    id: 20,
    name: "Paint",
    category: "Cat",
    sex: "Male",
    color: ["Orange"],
    breed: "Shorthair",
    age: "3-year old",
    image: "../images/Furr-Ever friends near you_1.png",
  },

  {
    id: 21,
    name: "Ginger",
    category: "Dog",
    sex: "Female",
    color: "Ginger",
    breed: "Retriever",
    age: "5-month old",
    image: "../images/Screenshot2013.JPG",
  },

  {
    id: 22,
    name: "Tux",
    category: "Cat",
    sex: "Male",
    color: ["Black", "White"],
    breed: "Tuxedo",
    age: "1-year old",
    image: "../images/Screenshot2012.jpg",
  },
  {
    id: 23,
    name: "Connie",
    category: "Dog",
    sex: "Female",
    color: "Black",
    breed: "Retriever",
    age: "5-month old",
    image: "../images/Furr-Ever friends near you_3.png",
  },

  {
    id: 24,
    name: "Asame",
    category: "Small Critter",
    sex: "Male",
    color: ["Brown"],
    breed: "Ferret",
    age: "3-year old",
    image: "../images/Screenshot2011.jpg",
  },

  {
    id: 25,
    name: "June",
    category: "Dog",
    sex: "Male",
    color: ["Brown"],
    breed: "German Shepard",
    age: "3-year old",
    image: "../images/Screenshot2030.JPG",
  },
  {
    id: 26,
    name: "Bailey",
    category: "Dog",
    sex: "Male",
    color: ["Brown"],
    breed: "Retriver",
    age: "3-year old",
    image: "../images/Screenshot2040.JPG",
  },
  {
    id: 27,
    name: "Cookie",
    category: "Dog",
    sex: "Male",
    color: ["Brown"],
    breed: "Doodle",
    age: "3-year old",
    image: "../images/Screenshot2031.JPG",
  },

  {
    id: 28,
    name: "Honey",
    category: "Dog",
    sex: "Male",
    color: ["Grey"],
    breed: "American Shorthair",
    age: "3-year old",
    image: "../images/Furr-Ever friends near you_2.png",
  },
];
